/**
 * html-input-types constants.
 *
 * Created via the const-add flow (subfile mode).
 */

// INPUT TYPES

/** The native input types whose value the browser's own picker sets -- a calendar, a clock -- rather than typing. The
 *  shared `Input` opens that picker on a press anywhere in the box, not only on its small icon, and sizes the box to its
 *  value rather than the row (operator, 2026-09-28: "when i click the date the calendar doesnt open and the field itself
 *  is too big"). */
export const NATIVE_PICKER_INPUT_TYPES: ReadonlySet<unknown> = new Set(['date', 'time', 'datetime-local', 'month', 'week']);
